import type { Menu } from '@/menus/types.ts';
import { apiPermissionCode } from '@ts-max/car-export-api-permission-code-sdk';
export default [
  {
    code: 'PLATFORM',
    icon: 'menu-platform',
    label: '平台管理',
    placement: 'bottom',
    remark: '平台管理下是管理企业使用的功能，不要开放给普通企业',
    children: [
      {
        code: 'TENANT',
        icon: 'menu-tenant',
        label: '企业管理',
        path: '/platform/tenant',
        dependencies: [
          apiPermissionCode.API_TENANT_FIND_MANY,
          apiPermissionCode.API_TENANT_FIND_ALL,
          apiPermissionCode.API_TENANT_EXPORT_MANY,
          apiPermissionCode.API_TENANT_CREATE,
          apiPermissionCode.API_TENANT_FIND_ONE,
          apiPermissionCode.API_TENANT_UPDATE,
          apiPermissionCode.API_TENANT_ASSIGN_MENUS,
          apiPermissionCode.API_TENANT_GET_MY_THIRD_PARTY_CONFIGS,
          apiPermissionCode.API_TENANT_GET_THIRD_PARTY_CONFIGS,
          apiPermissionCode.API_TENANT_SAVE_THIRD_PARTY_CONFIG,
          apiPermissionCode.API_TENANT_REMOVE,
          apiPermissionCode.API_TENANT_REMOVE_MANY,
        ],
      },
    ],
  },
] satisfies Menu[];
